import React, { useCallback } from 'react';
import Layout from '../../components/Layout';
// 1. Correct Import: Changed 'Web3Wallet' to 'Wallet'
import { Zap, Link, Wallet } from 'lucide-react'; 

const AboutProject = () => {
    
    // --- MetaMask Connection Mock (In a real app, this would use Ethers.js/Wagmi) ---
    const connectMetaMask = useCallback(async () => {
        // Check if the Ethereum provider (MetaMask) is available
        if (typeof window.ethereum !== 'undefined') {
            try {
                // Request account access
                const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
                alert(`MetaMask Connected! Address: ${accounts[0].substring(0, 6)}...${accounts[0].slice(-4)}`);
                // In a real app, you would save the connected account state here
            } catch (error) {
                console.error("User rejected connection or an error occurred:", error);
                alert("Connection failed. Please check MetaMask and try again.");
            }
        } else {
            alert("MetaMask is not installed. Please install it to connect your wallet.");
            // You could redirect the user to the MetaMask download page here
        }
    }, []);

    // --- Crypto Tracking Links Data ---
    const cryptoLinks = [
        { name: 'CoinGecko (DOGE)', url: 'https://www.coingecko.com/en/coins/dogecoin', description: 'Real-time price, market cap, and chart data.' },
        { name: 'CoinMarketCap (DOGE)', url: 'https://coinmarketcap.com/currencies/dogecoin/', description: 'Global ranking and historical price movements.' },
        { name: 'Etherscan', url: 'https://etherscan.io/', description: 'Blockchain explorer for Ethereum transactions and contracts.' },
    ];

    return (
        <Layout>
            <div className="py-12 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                
                {/* Header and Connect Button */}
                <div className="flex justify-between items-start mb-6 border-b-2 border-indigo-500 pb-4">
                    <h2 className="text-4xl font-extrabold text-teal-400">
                        About This Decentralized MVP
                    </h2>
                    <button
                        onClick={connectMetaMask}
                        className="flex items-center space-x-2 bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-2 px-4 rounded-lg transition duration-200 shadow-lg shadow-indigo-500/50"
                    >
                        {/* 2. Correct Usage: Changed 'Web3Wallet' to 'Wallet' */}
                        <Wallet className="w-5 h-5" />
                        <span>Connect Wallet</span>
                    </button>
                </div>
                
                <p className="text-gray-300 mb-6 text-lg">
                    This Minimum Viable Product (MVP) was developed to demonstrate expertise in modern Web3 architecture, 
                    specifically focusing on decentralized data retrieval and secure user interaction. 
                    It serves as a core proof-of-concept for **real-time crypto payment processing and dApp interaction**.
                </p>

                {/* Tech Stack */}
                <h3 className="text-2xl font-semibold text-white mt-8 mb-4">Tech Stack Highlights:</h3>
                <ul className="list-disc list-inside text-gray-400 space-y-2 mb-10">
                    <li>**Frontend:** React (SPA) with Tailwind CSS for rapid, modern UI.</li>
                    <li>**Web3 Integration:** Ethers.js / Web3.js for connecting to **EVM-compatible Blockchains**.</li>
                    <li>**Data Layer:** Utilizing **Mock APIs / Client-side Logic** for real-time pricing demonstration. (To be replaced by Chainlink Oracles in full product).</li>
                </ul>

                {/* Crypto Links Section */}
                <h3 className="text-2xl font-semibold text-white mt-8 mb-4 flex items-center space-x-2">
                    <Zap className="w-6 h-6 text-yellow-500" />
                    <span>Live Market & Block Links</span>
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    {cryptoLinks.map((link, index) => (
                        <a
                            key={index}
                            href={link.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="p-4 bg-gray-800 rounded-lg hover:bg-gray-700 transition duration-300 border border-gray-700 hover:border-teal-500 group"
                        >
                            <div className="flex items-center space-x-2">
                                <Link className="w-5 h-5 text-teal-400 group-hover:text-yellow-400" />
                                <span className="font-bold text-white group-hover:text-teal-400">{link.name}</span>
                            </div>
                            <p className="text-sm text-gray-400 mt-1">{link.description}</p>
                        </a>
                    ))}
                </div>
            </div>
        </Layout>
    );
};

export default AboutProject;
